import styled from 'styled-components';
import { Flex } from 'UI';

export const IAMTiresContainer = styled(Flex)`
  position: relative;
`;
